import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "fs20 mt20 fw600 centered" }, "仲介メニュー", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "fs14 mt20 fw600" }, "最初の提案時に自動で公開ページを作成", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " 提案があった場合に、提案があった日程を自動で別の公開ページにコピーします。コピーした調整カレンダーは、再提案があった場合も自動で更新されます。 ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "fs14 mt20 fw600" }, "自動作成した場合に、スケジュール一覧を自動公開", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "自動作成した場合に、スケジュール一覧を自動公開します。", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { class: "mt40" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "fs14 mt20 fw600" }, "自動作成した場合に概要を送信するメール送信先を設定", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " 自動作成した場合に概要を送信するメール送信先を設定します。メールアドレスは、カンマ区切りで複数設定できます。 ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "mt20"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "fr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_AutoCreateRoomRuleList = _resolveComponent("AutoCreateRoomRuleList")!
  const _component_IconLock = _resolveComponent("IconLock")!
  const _component_AutoCreateRoomRuleEditDetailContent = _resolveComponent("AutoCreateRoomRuleEditDetailContent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      (!_ctx.rcm.selectedRule)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _hoisted_3,
              _hoisted_4,
              _createVNode(_component_Switcher, {
                value: "type[chukai_is_create_pub_room_if_voted]",
                name: "提案があった場合に、提案があった日程を自動で別の公開ページにコピーできるようになります.",
                checked: _ctx.rcm.room_setting.chukai_is_create_pub_room_if_voted,
                display: "true",
                class: "checkUsingCal fl",
                onSelect: _ctx.changeChukaiIsCreatePubRoomIfVoted
              }, null, 8, ["checked", "onSelect"]),
              _hoisted_5
            ]),
            _createElementVNode("div", null, [
              _hoisted_6,
              _hoisted_7,
              _createVNode(_component_Switcher, {
                value: "type[chukai_is_available_open_schedule]",
                name: "自動作成した場合に、スケジュール一覧を自動公開します.",
                checked: _ctx.rcm.room_setting.chukai_is_available_open_schedule,
                display: "true",
                class: "checkUsingCal fl",
                onSelect: _ctx.changeChukaiIsAvailableOpenSchedule
              }, null, 8, ["checked", "onSelect"]),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _createVNode(_component_TextfieldTag, {
                placeholder: "メールアドレス",
                style: {"height":"50px"},
                class: "fl fs14 roundForm mw100",
                value: _ctx.chukaiEmails,
                onInputValue: _ctx.inputChukaiSendMailSummaryToEmails,
                onBlur: _ctx.updateChukaiSendMailSummaryToEmails
              }, null, 8, ["value", "onInputValue", "onBlur"]),
              _hoisted_12
            ]),
            _hoisted_13,
            (_ctx.rm.canUseOption(`room_chukai_menu`, false))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_ctx.rcm.ac_rules.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rcm.ac_rules, (rule, ruleindex) => {
                          return (_openBlock(), _createElementBlock("div", { key: ruleindex }, [
                            _createVNode(_component_AutoCreateRoomRuleList, {
                              rule: rule,
                              ruleindex: ruleindex,
                              onEditContent: _ctx.editContent,
                              onRemoveRule: _ctx.removeRule
                            }, null, 8, ["rule", "ruleindex", "onEditContent", "onRemoveRule"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16)),
            _createElementVNode("div", {
              class: "w100 pad10 circle_button blueAround rad8 mt20 centered fw600",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addRule && _ctx.addRule(...args)))
            }, [
              _createTextVNode(" 自動作成ルールを追加 "),
              (!_ctx.rm.canUseOption(`room_chukai_menu`, false))
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_component_IconLock, {
                      style: {},
                      class: "",
                      width: 16
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("section", {
            key: 1,
            class: _normalizeClass(`${_ctx.isSP ? `` : ``} mt10`)
          }, [
            _createVNode(_component_AutoCreateRoomRuleEditDetailContent)
          ], 2))
    ])
  ]))
}